import React from 'react';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';

export default function TabContainer({ children }) {
    return (
        <Typography component="div" className="flex_full padding_bottom_24 overflow_y_scroll">
            {children}
        </Typography>
    );
}

TabContainer.propTypes = {
    children: PropTypes.node.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/complex/xhef/TabContainer.js